import React, { forwardRef } from 'react'

import styled from 'styled-components'

import Column from './Column'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

type Ref = HTMLDivElement

type Props = React.PropsWithChildren<{
  className?: string
}>

interface CompoundedComponent
  extends React.ForwardRefExoticComponent<Props> {
  Column: typeof Column
}

const ColumnGridPanel = forwardRef<Ref, Props>(({ children, className }: Props, ref) => {
  return (
    <S.ColumnGridPanel ref={ref} {...{ className }}>
      {children}
    </S.ColumnGridPanel>
  )
}) as CompoundedComponent

ColumnGridPanel.Column = Column

export default ColumnGridPanel

const S = {
  ColumnGridPanel: styled.div`
    margin: 0px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-column-gap: 1px;
    background-color: ${color('infoPanelContentBackground')};
    border: 1px solid ${color('columnBorder')};

    & > :nth-child(odd) {
      background-color: ${color('paneBackground')};
    }
    & > :nth-child(even) {
      @media ${screenSize.small} {
        margin-right: 0px;
        border-right: none;
      }
    }
  `
}
